import React, { useEffect } from 'react'
import {
  Button,
  Checkbox,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Space,
} from 'antd'
import { FormActionFooter } from '../ConnectedDocumentIncomingDocCreatePage/ConnectedDocumentIncomingDocCreatePageStyled'
import { BankOutlined, CloseOutlined, TeamOutlined } from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import { useState } from 'react'
import { SelectPeopleWrapper } from '../WorkPage/PopupVote/PopupVoteStyled'
import SelectUserButton from '../../components/Common/SelectUserButton'
import { ASSIGNEE_TYPE } from '../../constants'
import utils from '../../utils'
import { AvatarHasName } from '../../components/Common/Avatar'
import SelectListComponentRisk from '../../components/Common/SelectListComponentRisk'
import { systemName } from '../../config'
import SelectRiskGroupPopup from './SelectRiskGroupPopup'
// import SelectGroupPopup from '../../components/SelectGroupPopup'
// import SelectGroupPopup from '../Documents/FeedbackBoard/components/SelectGroupPopup'

const RiskWorkCreatePopup = ({
  handleCancel,
  isVisible,
  actionStore,
  riskStore,
  getRiskDetail,
  selectUserList,
  selectPeopleStore,
  handleVisibleSelectOneUserPopup,
  type,
  positionStore,
}) => {
  const {
    indexDetailAction,
    dataActions,
    setDataActions,
    createAction,
    updateAction,
  } = actionStore
  const {
    handleOpenSelectUserDepartmentPopup,
    isVisibleSelectGroupPopup,
    isVisibleSelectGroupPopupv2,
    setIsVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopupv2,
    handleCancelSelectGroup,
    handleCancelSelectGroupv2,
    handleOpenSelectGroupPopup,
    handleOpenSelectGroupPopupv2,
    setSelectUserData,
    selectUserData,
    clearSelectedByType,
    originDepartmentWithUserList,
  } = selectPeopleStore
  const { riskDetail } = riskStore
  const { positionList } = positionStore
  useEffect(() => {
    positionStore.getPositionList()
  }, [])
  function convertCodeOrCodesToName(input) {
    const codes = input?.split(',').map(code => code.trim())
    const names = codes?.map(code => {
      const role = positionList?.find(role => role.code === code)
      return role ? role?.name : 'Không tìm thấy chức danh'
    })
    return names?.join(', ')
  }
  const [form] = Form.useForm()
  const [isRenderRichText, setIsRenderRichText] = useState(false)
  const [tier3Checking, setTier3Checking] = useState(null)
  const [tier3, setTier3] = useState()
  useEffect(() => {
    if (dataActions?.tier3?.length > 0) {
      setTier3(dataActions?.tier3[0])
    }
  }, [dataActions])

  useEffect(() => {
    if (!tier3 || indexDetailAction?.tier !== '3') {
      return
    }
    form.resetFields()
    setSelectUserData({
      ...selectUserData,
      [ASSIGNEE_TYPE.ban_kt_ktnb]: tier3?.doi_tuong_thuc_hien?.ban_kt_ktnb,
      [ASSIGNEE_TYPE.tgd_ptgd]: tier3?.doi_tuong_thuc_hien?.tgd_ptgd,
      [ASSIGNEE_TYPE.ban_kt_ktnb_vimc]:
        tier3?.IV_ket_qua_ra_soat_rui_ro?.ban_kt_ktnb_vimc,
      [ASSIGNEE_TYPE.hdqt_vimc]: tier3?.IV_ket_qua_ra_soat_rui_ro?.hdqt_vimc,
      [ASSIGNEE_TYPE.ban_dieu_hanh]:
        tier3?.IV_ket_qua_ra_soat_rui_ro?.ban_dieu_hanh,
    })
    setTier3Checking(tier3.doi_tuong_thuc_hien.cac_don_vi_thuoc_cq_vp_cua_vimc)
    form.setFieldsValue({
      tgd_ptgd: tier3?.doi_tuong_thuc_hien?.tgd_ptgd,
      cac_don_vi_thuoc_cq_vp_cua_vimc:
        tier3?.doi_tuong_thuc_hien?.cac_don_vi_thuoc_cq_vp_cua_vimc,
      dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai:
        tier3?.IV_ket_qua_ra_soat_rui_ro
          ?.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai,
      dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_ban_dh:
        tier3?.IV_ket_qua_ra_soat_rui_ro
          ?.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_ban_dh,
      dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_hdqt:
        tier3?.IV_ket_qua_ra_soat_rui_ro
          ?.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_hdqt,
      kien_nghi_giai_phap_khac_phuc:
        tier3?.IV_ket_qua_ra_soat_rui_ro?.kien_nghi_giai_phap_khac_phuc,
      kien_nghi_giai_phap_khac_phuc_ban_dh:
        tier3?.IV_ket_qua_ra_soat_rui_ro?.kien_nghi_giai_phap_khac_phuc_ban_dh,
      kien_nghi_giai_phap_khac_phuc_hdqt:
        tier3?.IV_ket_qua_ra_soat_rui_ro?.kien_nghi_giai_phap_khac_phuc_hdqt,
      ban_kt_ktnb_vimc: tier3?.IV_ket_qua_ra_soat_rui_ro?.ban_kt_ktnb_vimc,
      ban_dieu_hanh: tier3?.IV_ket_qua_ra_soat_rui_ro?.ban_dieu_hanh,
      hdqt_vimc: tier3?.IV_ket_qua_ra_soat_rui_ro?.hdqt_vimc,
      ban_ktnb_vimc_signed:
        tier3?.IV_ket_qua_ra_soat_rui_ro?.ban_ktnb_vimc_signed,
      ban_dieu_hanh_signed:
        tier3?.IV_ket_qua_ra_soat_rui_ro?.ban_dieu_hanh_signed,
      hdqt_vimc_signed: tier3?.IV_ket_qua_ra_soat_rui_ro?.hdqt_vimc_signed,
    })
  }, [indexDetailAction, tier3, form])
  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        setIsRenderRichText(true)
      }, 100)
    } else {
      setIsRenderRichText(false)
    }
  }, [isVisible])

  const handleCancelModal = () => {
    form.resetFields()
    handleCancel()
  }

  const handleSubmit = async value => {
    const submitData = {
      name: 'Tuyến phòng vệ thứ ba',
      doi_tuong_thuc_hien: {
        tong_giam_doc_cac_pho_tong_giam_doc:
          value.tong_giam_doc_cac_pho_tong_giam_doc,
        ban_kt_ktnb: selectUserList.ban_kt_ktnb,
        tgd_ptgd: selectUserList.tgd_ptgd,
        cac_don_vi_thuoc_cq_vp_cua_vimc: value.cac_don_vi_thuoc_cq_vp_cua_vimc,
      },
      IV_ket_qua_ra_soat_rui_ro: {
        dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai:
          value.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai,
        dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_ban_dh:
          value.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_ban_dh,
        dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_hdqt:
          value.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_hdqt,
        kien_nghi_giai_phap_khac_phuc: value.kien_nghi_giai_phap_khac_phuc,
        kien_nghi_giai_phap_khac_phuc_ban_dh:
          value.kien_nghi_giai_phap_khac_phuc_ban_dh,
        kien_nghi_giai_phap_khac_phuc_hdqt:
          value.kien_nghi_giai_phap_khac_phuc_hdqt,
        ban_kt_ktnb_vimc: selectUserList.ban_kt_ktnb_vimc,
        hdqt_vimc: selectUserList.hdqt_vimc,
        ban_dieu_hanh: selectUserList.ban_dieu_hanh,
        ban_ktnb_vimc_signed:
          checked_ktnb === true ? value.ban_ktnb_vimc_signed : null,
        ban_dieu_hanh_signed:
          checked_bdh === true ? value.ban_dieu_hanh_signed : null,
        hdqt_vimc_signed: checked_hdqt === true ? value.hdqt_vimc_signed : null,
      },
    }
    if (riskDetail?.tiers) {
      if (riskDetail?.tiers[2]?.actions[0]) {
        await updateAction(riskDetail?.tiers[2]?.actions[0]?.code, {
          name: 'Rủi ro nhận diện 3 update',
          data: JSON.stringify(submitData),
          risk_tier_code: riskDetail?.tiers[2]?.code,
          risk_type: type,
        })
      } else {
        await createAction({
          ...submitData,
          data: JSON.stringify(submitData),
          risk_tier_code: riskDetail?.tiers[2]?.code,
        })
      }
      message.success('Lưu thành công')
      handleCancelModal()
      getRiskDetail()
    } else {
      message.success('Lưu thành công')
      setDataActions({ ...dataActions, tier3: [submitData] })
      handleCancelModal()
    }
  }
  const [radioValue, setRadioValue] = useState()
  const [radioValueDH, setRadioValueDH] = useState()
  const [radioValueQT, setRadioValueQT] = useState()
  useEffect(() => {
    setRadioValue(
      tier3?.IV_ket_qua_ra_soat_rui_ro
        ?.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai
    )
    setRadioValueDH(
      tier3?.IV_ket_qua_ra_soat_rui_ro
        ?.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_ban_dh
    )
    setRadioValueQT(
      tier3?.IV_ket_qua_ra_soat_rui_ro
        ?.dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_hdqt
    )
  }, [dataActions])
  const onChange = e => {
    setRadioValue(e.target.value)
  }
  const onChangeDH = e => {
    setRadioValueDH(e.target.value)
  }
  const onChangeQT = e => {
    setRadioValueQT(e.target.value)
  }
  const [checked_ktnb, setChecked_ktnb] = useState(false)
  const [checked_bdh, setChecked_bdh] = useState(false)
  const [checked_hdqt, setChecked_hdqt] = useState(false)
  const [disabled_ktnb, setDisabled_ktnb] = useState(true)
  const [disabled_bdh, setDisabled_bdh] = useState(true)
  const [disabled_hdqt, setDisabled_hdqt] = useState(true)

  const onChangeCheckedKtnb = e => {
    setChecked_ktnb(e.target.checked)
  }
  const onChangeCheckedBdh = e => {
    setChecked_bdh(e.target.checked)
  }
  const onChangeCheckedHdqt = e => {
    setChecked_hdqt(e.target.checked)
  }

  useEffect(() => {
    if (
      dataActions?.tier3[0]?.IV_ket_qua_ra_soat_rui_ro?.ban_ktnb_vimc_signed ===
      '(Đã ký)'
    ) {
      setChecked_ktnb(true)
    }
    if (
      dataActions?.tier3[0]?.IV_ket_qua_ra_soat_rui_ro?.ban_dieu_hanh_signed ===
      '(Đã ký)'
    ) {
      setChecked_bdh(true)
    }
    if (
      dataActions?.tier3[0]?.IV_ket_qua_ra_soat_rui_ro?.hdqt_vimc_signed ===
      '(Đã ký)'
    ) {
      setChecked_hdqt(true)
    }
  }, [dataActions])
  useEffect(() => {
    if (selectUserList.ban_kt_ktnb_vimc.length > 0) {
      setDisabled_ktnb(false)
    } else {
      setChecked_ktnb(false)
      setDisabled_ktnb(true)
    }
  }, [selectUserList.ban_kt_ktnb_vimc.length])
  useEffect(() => {
    if (selectUserList.ban_dieu_hanh.length > 0) {
      setDisabled_bdh(false)
    } else {
      setChecked_bdh(false)
      setDisabled_bdh(true)
    }
  }, [selectUserList.ban_dieu_hanh.length])
  useEffect(() => {
    if (selectUserList.hdqt_vimc.length > 0) {
      setDisabled_hdqt(false)
    } else {
      setChecked_hdqt(false)
      setDisabled_hdqt(true)
    }
  }, [selectUserList.hdqt_vimc.length])

  return (
    <>
      <Modal
        width={800}
        style={{ top: 40 }}
        title={'Tạo mới công việc thực hiện'}
        visible={isVisible}
        maskClosable={false}
        onCancel={() => {
          handleCancelModal()
        }}
        destroyOnClose={true}
        afterClose={() => {
          setIsRenderRichText(false)
        }}
        forceRender={true}
        zIndex={500}
        footer={null}>
        <Form
          form={form}
          layout={'vertical'}
          onFinish={handleSubmit}
          preserve={false}>
          <h3>C. Tuyến phòng vệ thứ ba</h3>
          <h3>
            Đối tượng thực hiện:{' '}
            {/* <span style={{ fontWeight: 400 }}>Đồng thời cả 2</span> */}
          </h3>
          {type !== 'CQVP' ? (
            <>
              <SelectPeopleWrapper>
                <SelectUserButton
                  style={{ marginTop: 16 }}
                  title="- Tổng giám đốc, các Phó Tổng giám đốc:"
                  tooltipTitle="Chọn người"
                  handleOnClick={() => {
                    handleVisibleSelectOneUserPopup()
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.tgd_ptgd)
                  }}
                />
                <SelectListComponentRisk
                  userList={selectUserList.tgd_ptgd}
                  originDepartmentWithUserList={originDepartmentWithUserList}
                  convertCodeOrCodesToName={convertCodeOrCodesToName}
                />
              </SelectPeopleWrapper>
              {/* <Form.Item
          name={'ban_kt_ktnb'}
          label={'(2)	Ban KTNB (tham mưu đánh giá độc lập cho HĐQT) :'}>
          <Input placeholder={'Nhập nội dung'} />
        </Form.Item> */}
              <SelectPeopleWrapper>
                <SelectUserButton
                  style={{ marginTop: 16 }}
                  title="- Ban KTNB (tham mưu đánh giá độc lập cho HĐQT):"
                  tooltipTitle="Chọn người"
                  handleOnClick={() => {
                    handleVisibleSelectOneUserPopup()
                    handleOpenSelectUserDepartmentPopup(
                      ASSIGNEE_TYPE.ban_kt_ktnb
                    )
                  }}
                />
                <SelectListComponentRisk
                  userList={selectUserList.ban_kt_ktnb}
                  originDepartmentWithUserList={originDepartmentWithUserList}
                  convertCodeOrCodesToName={convertCodeOrCodesToName}
                />
              </SelectPeopleWrapper>
            </>
          ) : (
            <Form.Item
              name={'cac_don_vi_thuoc_cq_vp_cua_vimc'}
              style={{ width: '100%', marginBottom: '10px' }}>
              <Checkbox.Group>
                <Checkbox value={'tbtt_hdqt'}>
                  <span style={{ fontWeight: 'bold' }}>
                    1. Các Tiểu ban trực thuộc HĐQT:{' '}
                  </span>
                  <span style={{ fontStyle: 'italic' }}>
                    Thực hiện việc thẩm định, đánh giá độc lập và đưa ra các ý
                    kiến tư vấn, tham mưu cho HĐQT kiểm soát rủi ro ở tuyến
                    phòng vệ thứ 3.
                  </span>
                </Checkbox>
                <Checkbox value={'tv_hdqt'} style={{ margin: 0 }}>
                  <span style={{ fontWeight: 'bold' }}>
                    2. Thành viên Hội đồng quản trị:{' '}
                  </span>
                  <span style={{ fontStyle: 'italic' }}>
                    Xem xét lại các nhận diện, đánh giá rủi ro, kiểm soát rủi ro
                    ở tuyến phòng vệ thứ nhất, thứ hai, ý kiến thẩm định độc lập
                    của Tiểu ban. Trực tiếp có ý kiến đánh giá, đề nghị giải
                    trình theo quyền hạn ở tuyến phòng vệ thứ ba.
                  </span>
                </Checkbox>
                <Checkbox value={'bks_hdqt'} style={{ margin: 0 }}>
                  <span style={{ fontWeight: 'bold' }}>3. Ban Kiểm soát: </span>
                  <span style={{ fontStyle: 'italic' }}>
                    Có ý kiến kiểm soát theo thẩm quyền ở tuyến phòng vệ thứ ba
                    đối với các trường hợp Ban Kiểm soát phát hiện vấn đề rủi ro
                    hoặc có ý kiến khác.
                  </span>
                </Checkbox>
              </Checkbox.Group>
            </Form.Item>
          )}
          <h3>IV. KẾT QUẢ RÀ SOÁT RỦI RO</h3>
          <span>
            1. Đồng ý/không đồng ý với đánh giá rủi ro/xử lý rủi ro ở tầng phòng
            vệ thứ nhất và thứ hai:
          </span>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Form.Item
              name={
                'dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai'
              }>
              <div>
                {/* <SelectPeopleWrapper> */}
                <SelectUserButton
                  style={{ marginTop: 16, minWidth: '300px !important' }}
                  title={
                    type === 'CQVP' ? 'TIỂU BAN:' : `BAN KTNB ${systemName}:`
                  }
                  tooltipTitle={'Chọn người'}
                  handleOnClick={() => {
                    // handleVisibleSelectOneUserPopup()
                    handleOpenSelectGroupPopupv2(ASSIGNEE_TYPE.ban_kt_ktnb_vimc)
                    // handleOpenSelectUserDepartmentPopup(
                    //   ASSIGNEE_TYPE.ban_kt_ktnb_vimc
                    // )
                  }}
                />
                {/* <SelectListComponent userList={selectUserList.ban_kt_ktnb_vimc} /> */}
                {/* </SelectPeopleWrapper> */}
                {selectUserList.ban_kt_ktnb_vimc?.map(item => (
                  <div style={{ display: 'inline-block' }}>
                    <Radio.Button
                      style={{
                        borderRadius: '35px',
                        display: 'flex',
                        padding: '3px 8px 3px 4px',
                        marginRight: '0',
                        alignItems: 'center',
                        background: '#e6f7ff',
                        color: '#096de0',
                      }}
                      onClick={() => selectPeopleStore.handleRemoveSelect(item)}
                      value={``}>
                      <AvatarHasName
                        imgId={item.image_id}
                        size={22}
                        name={item.full_name}
                        icon={
                          (item.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (item.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                      {/* {item.full_name} */}
                    </Radio.Button>

                    <Radio.Group
                      style={{ minWidth: '145px' }}
                      onChange={onChange}
                      value={radioValue}>
                      <Space direction="vertical">
                        <span style={{ marginRight: 16 }}>
                          <Radio
                            value={`${utils.getNameInCapitalize(
                              item.full_name
                            )} - Đồng ý`}>
                            Đồng ý
                          </Radio>
                        </span>
                        <Radio
                          value={`${utils.getNameInCapitalize(
                            item.full_name
                          )} - Không đồng ý`}>
                          Không đồng ý
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                ))}
              </div>
            </Form.Item>
            <Form.Item
              name={
                'dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_ban_dh'
              }>
              <div>
                <SelectUserButton
                  style={{ marginTop: 16, minWidth: '200px !important' }}
                  title={type === 'CQVP' ? 'BAN KIỂM SOÁT:' : 'BAN ĐIỀU HÀNH:'}
                  tooltipTitle={'Chọn người'}
                  handleOnClick={() => {
                    handleVisibleSelectOneUserPopup()
                    handleOpenSelectUserDepartmentPopup(
                      ASSIGNEE_TYPE.ban_dieu_hanh
                    )
                  }}
                />

                {selectUserList.ban_dieu_hanh?.map(item => (
                  <>
                    <Radio.Button
                      style={{
                        borderRadius: '35px',
                        display: 'flex',
                        padding: '3px 8px 3px 4px',
                        marginRight: '0',
                        alignItems: 'center',
                        background: '#e6f7ff',
                        color: '#096de0',
                      }}
                      onClick={() => selectPeopleStore.handleRemoveSelect(item)}
                      value={``}>
                      <AvatarHasName
                        imgId={item.image_id}
                        size={22}
                        name={item.full_name}
                        icon={
                          (item.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (item.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Radio.Button>
                    <Radio.Group
                      style={{ minWidth: '130px' }}
                      onChange={onChangeDH}
                      value={radioValueDH}>
                      <Space direction="vertical">
                        <span style={{ marginRight: 16 }}>
                          <Radio
                            value={`${utils.getNameInCapitalize(
                              item.full_name
                            )} - Đồng ý`}>
                            Đồng ý
                          </Radio>
                        </span>
                        <Radio
                          value={`${utils.getNameInCapitalize(
                            item.full_name
                          )} - Không đồng ý`}>
                          Không đồng ý
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </>
                ))}
              </div>
            </Form.Item>
            <Form.Item
              name={
                'dong_y_voi_danh_gia_rui_ro_xu_ly_rui_ro_o_tang_phong_ve_thu_nhat_va_thu_hai_hdqt'
              }>
              <div>
                <SelectUserButton
                  style={{ marginTop: 16, minWidth: '200px !important' }}
                  title={
                    type === 'CQVP'
                      ? 'TV HĐQT:'
                      : `HĐQT ${systemName} (CT/TV HĐQT):`
                  }
                  tooltipTitle={'Chọn người'}
                  handleOnClick={() => {
                    handleVisibleSelectOneUserPopup()
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.hdqt_vimc)
                  }}
                />
                {selectUserList.hdqt_vimc?.map(item => (
                  <>
                    <Radio.Button
                      style={{
                        borderRadius: '35px',
                        display: 'flex',
                        padding: '3px 8px 3px 4px',
                        marginRight: '0',
                        alignItems: 'center',
                        background: '#e6f7ff',
                        color: '#096de0',
                      }}
                      onClick={() => selectPeopleStore.handleRemoveSelect(item)}
                      value={``}>
                      <AvatarHasName
                        imgId={item.image_id}
                        size={22}
                        name={item.full_name}
                        icon={
                          (item.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (item.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Radio.Button>
                    <Radio.Group
                      style={{ minWidth: '180px' }}
                      onChange={onChangeQT}
                      value={radioValueQT}>
                      <Space direction="vertical">
                        <span style={{ marginRight: 16 }}>
                          <Radio
                            value={`${utils.getNameInCapitalize(
                              item.full_name
                            )} - Đồng ý`}>
                            Đồng ý
                          </Radio>
                        </span>
                        <Radio
                          value={`${utils.getNameInCapitalize(
                            item.full_name
                          )} - Không đồng ý`}>
                          Không đồng ý
                        </Radio>
                      </Space>
                    </Radio.Group>
                  </>
                ))}
              </div>
            </Form.Item>
          </div>

          <span>2. Kiến nghị giải pháp khắc phục:</span>
          <Form.Item
            name={'kien_nghi_giai_phap_khac_phuc'}
            label={`2.1	Kiến nghị giải pháp khắc phục TIỂU BAN:`}>
            <Input placeholder={'Nhập nội dung'} />
          </Form.Item>
          <Form.Item
            name={'kien_nghi_giai_phap_khac_phuc_ban_dh'}
            label={'2.2	Kiến nghị giải pháp khắc phục BAN KIỂM SOÁT:'}>
            <Input placeholder={'Nhập nội dung'} />
          </Form.Item>
          <Form.Item
            name={'kien_nghi_giai_phap_khac_phuc_hdqt'}
            label={`2.3	Kiến nghị giải pháp khắc phục TV HĐQT:`}>
            <Input placeholder={'Nhập nội dung'} />
          </Form.Item>

          <Divider />
          <SelectPeopleWrapper>
            <span>TIỂU BAN:</span>
            <Form.Item name={'ban_ktnb_vimc_signed'}>
              <Space direction="vertical">
                <Checkbox
                  checked={checked_ktnb}
                  disabled={disabled_ktnb}
                  onChange={e => onChangeCheckedKtnb(e)}
                  value={'(Đã ký)'}>
                  Xác nhận ký
                </Checkbox>
              </Space>
            </Form.Item>
            <SelectListComponentRisk
              userList={selectUserList.ban_kt_ktnb_vimc}
              originDepartmentWithUserList={originDepartmentWithUserList}
              convertCodeOrCodesToName={convertCodeOrCodesToName}
            />
          </SelectPeopleWrapper>
          <SelectPeopleWrapper>
            <span>BAN KIỂM SOÁT:</span>
            <Form.Item name={'ban_dieu_hanh_signed'}>
              <Space direction="vertical">
                <Checkbox
                  checked={checked_bdh}
                  disabled={disabled_bdh}
                  onChange={e => onChangeCheckedBdh(e)}
                  value={'(Đã ký)'}>
                  Xác nhận ký
                </Checkbox>
              </Space>
            </Form.Item>
            <SelectListComponentRisk
              userList={selectUserList.ban_dieu_hanh}
              convertCodeOrCodesToName={convertCodeOrCodesToName}
            />
          </SelectPeopleWrapper>
          <SelectPeopleWrapper>
            <span>TV HĐQT:</span>
            <Form.Item name={'hdqt_vimc_signed'}>
              <Space direction="vertical">
                <Checkbox
                  checked={checked_hdqt}
                  disabled={disabled_hdqt}
                  onChange={e => onChangeCheckedHdqt(e)}
                  value={'(Đã ký)'}>
                  Xác nhận ký
                </Checkbox>
              </Space>
            </Form.Item>
            <SelectListComponentRisk
              userList={selectUserList.hdqt_vimc}
              convertCodeOrCodesToName={convertCodeOrCodesToName}
            />
          </SelectPeopleWrapper>

          <FormActionFooter style={{ marginBottom: 0, marginRight: 0 }}>
            <Button icon={<CloseOutlined />} danger onClick={handleCancelModal}>
              Đóng
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              type={'primary'}
              htmlType={'submit'}>
              Lưu thông tin
            </Button>
          </FormActionFooter>
        </Form>
      </Modal>
      <SelectRiskGroupPopup
        isPhieuruiro={true}
        width={800}
        onlySelectOne={true}
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopupv2}
        handleCancelSelectGroup={handleCancelSelectGroupv2}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopupv2(false)}
      />
    </>
  )
}

export default inject(
  'riskStore',
  'actionStore',
  'selectPeopleStore',
  'positionStore'
)(observer(RiskWorkCreatePopup))
